<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      top="20vh"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新建大屏"
      :append-to-body="false"
      :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" class="form" @submit.native.prevent="handleSubmit">
        <!-- 大屏创建类型 -->
        <el-form-item label="大屏" prop="screenType">
          <el-radio-group v-model="form.screenType" class="screen-type-radio">
            <el-radio :label="1">以模版创建</el-radio>
            <el-radio :label="2">空白大屏</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 大屏模板选择 -->
        <el-form-item v-if="form.screenType === 1" label="模版" prop="templateId">
          <el-radio-group v-model="form.templateId" class="template-radio">
            <el-radio v-for="(item,i) in SCREEN_TEMPLATE_LIST" :key="i" :label="item.templateId">
              <div class="template-img-wrap">
                <img :src="item.panelThumbnail" alt="">
                <span class="img-zoom-wrap" @click.stop.prevent="handleViewTemplate(item)">
                  <i class="el-icon-zoom-in zoom-in"></i>
                </span>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 大屏名称 -->
        <el-form-item label="大屏名称" prop="panelName">
          <el-input v-model="form.panelName" class="screen-name-input" :maxlength="10" show-word-limit placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageFullScreen from '@/widget/Viewer'
import { saveScreenApi } from '../fetch'
import { SCREEN_TEMPLATE_LIST } from '@/utils/defaultTemplateData.js'
import {
  EMPTY_SCREEN_TEMPLATE,
} from '../data'
export default {
  name: 'RenameDialog',
  data () {
    return {
      EMPTY_SCREEN_TEMPLATE,
      SCREEN_TEMPLATE_LIST,
      dialogVisible: true,
      loading: false,
      btnLoading: false,
      form: {
        panelName: '',
        screenType: 1,
        templateId: undefined,
      },
      rules: {
        panelName: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
        ],
        screenType: [
          { required: true, message: '请选择', trigger: ['change', 'blur'] },
        ],
        templateId: [
          { required: true, message: '请选择', trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        this.btnLoading = true
        let params = null
        if (this.form.screenType === 1) {
          params = SCREEN_TEMPLATE_LIST.find(bar => bar.templateId === this.form.templateId)
        } else {
          params = EMPTY_SCREEN_TEMPLATE
          if (params.backgroundType === 1) {
            params.backgroundColor = params.background
          } else {
            params.backgroundTemplate = params.background
          }
        }

        params.panelName = this.form.panelName
        const panelInfo = await saveScreenApi(params)
        this.$success('操作成功')
        this.dialogVisible = false
        this.$router.push({
          path: `/screen/edit/${panelInfo.panelSn}`,
        })
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
    handleViewTemplate (item) {
      ImageFullScreen({
        list: [{ url: item.panelThumbnail }],
        itemKey: 'url',
        index: 0,
      })
    },
  },
}
</script>

<style lang='scss' scoped>
  .form {
    width: 440px;
  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  ::v-deep .el-dialog{
    margin: auto !important;
    .el-dialog__header{
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E8E8E8;
      padding: 0 40px 0 30px !important;
      color: #1C1C1C;
      .el-dialog__headerbtn{
        width: 24px;
        height: 24px;
        background: #E8E8E8;
        border-radius: 50%;
      }
    }
    .el-dialog__body{
      display: flex;
      justify-content: center;
      padding: 40px 0 40px !important;
      .form{
        .screen-type-radio,.screen-name-input{
          width: 100%;
        }
        .el-form-item__label{
          color: #1C1C1C;
        }
        .template-radio{
          .el-radio{
            margin-right: 5px;
            text-align: center;
            .el-radio__inner{
              box-shadow: none;
            }
          }
          .el-radio__label{
            display: block;
            margin-top: 5px;
            padding: 0;
            .template-img-wrap{
              width: 140px;
              font-size: 0;
              overflow: hidden;
              position: relative;
              img{
                width: 100%;
                height: 100%;
              }
              &:hover{
                .img-zoom-wrap{
                  visibility: visible;
                }
              }
              .img-zoom-wrap{
                visibility: hidden;
                position: absolute;
                display: inline-block;
                width: 50px;
                height: 50px;
                transform: rotateZ(45deg);
                top: -25px;
                right: -25px;
                background: rgba(255,255,255,.7);
                &:hover{
                  .zoom-in{
                    color: #3269FF;
                  }
                }
                .zoom-in{
                  position: absolute;
                  left: 35%;
                  transform: rotateZ(-45deg);
                  bottom: 2px;
                  font-size: 14px;
                  font-weight: bold;
                  color: #606266;
                }
              }
            }
          }
        }
      }
    }
    .el-dialog__footer{
      display: flex;
      justify-content: center;
      padding: 0 0 40px;
    }
    .el-input__inner{
      height: 46px;
    }
  }
</style>
